import {customersSvg as Icon__small__customersSvg} from '../Icon__small/Icon__small--customers.js'

export var customers = {
  name: 'customers',
  category: 'icon',
  colorable: true,
  svg: Icon__small__customersSvg,
};
